<div class="overlay" [ngStyle]="styles" (click)="$event.stopPropagation()">
    <ng-content></ng-content>
</div>
